<template>
  <div>
    <v-layout
      row
      justify-center
    >
      <v-dialog
        v-model="cancelDialog"
        persistent
        max-width="530px"
      >
        <v-card>
          <form @submit.prevent="submitForm()">
            <v-card-title>
              <v-flex
                xs11
                sm11
                md11
              >
                <span class="headline">Cancel Export Order</span>
              </v-flex>
              <v-flex xs1>
                <v-btn
                  flat
                  class="close"
                  @click="$emit('close')"
                >
                  &times;
                </v-btn>
              </v-flex>
            </v-card-title>

            <v-card-text>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    label="Cancel Note"
                    v-model="form.cancel_note"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="height:auto"
                @click="$emit('close')"
                outline
                color="normal"
              >Cancel</v-btn>
              <v-btn
                type="submit"
                style="height:auto; margin-right: 4%"
                outline
                color="success"
              >Save</v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import Axios from 'axios'
import swal from 'sweetalert'

export default {
  props: [
    'cancelDialog',
    'id'
  ],

  data() {
    return {
      form: {
        cancel_note: null
      }
    }
  },

  methods: {
    submitForm() {
      let token = localStorage.getItem('access_token')
      Axios
        .put(`api/export-order/${this.id}/cancel`, this.form, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then(() => {
          swal({
            title: 'Canceled',
            text: '',
            icon: 'success',
            timer: 1500,
            buttons: false
          })
          this.$emit('update-table')
          this.$emit('close')
        })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/exportOrder/cancelExportOrder.vue